async function UploadImage (fileToUpload, componentid, userid) {

    if (true) {

            let response;
            let formData = new FormData();

            formData.append("file", fileToUpload)
            formData.append("folder", "images");
            formData.append("data", JSON.stringify(
                { 
                    "componentID": componentid,
                    "userID": userid
                }
            ));

            response = await fetch ("https://api.cssi.co/CNF/SaveFile", {
                method: "POST",
                body: formData})
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);        
            })

            return response;
    }
}
 
export default UploadImage;